const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_SALES_PLANNING",
    modulePath: "hml-new-netsuite.sales",
    moduleName: "sales",
    language: "pt",
    port: 8083,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
